import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { PurchaseProcess } from '@Purchasing/Domain/Model/PurchaseProcess'
import { UpdatePurchaseProcessPayload } from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'

export interface UpdatePurchaseProcess {
    execute(
        id: string,
        payload: UpdatePurchaseProcessPayload
    ): Promise<PurchaseProcess>
    getSource(): string
}

export class UpdatePurchaseProcessUseCase implements UpdatePurchaseProcess {
    constructor(private repository: PurchasingRepository) {}
    async execute(
        id: string,
        payload: UpdatePurchaseProcessPayload
    ): Promise<PurchaseProcess> {
        return this.repository.dataSource.updateProcess(id, payload)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
